import { Button } from '@givebutter/primitives/button';
import { startTour } from '@intercom/messenger-js-sdk';
import * as Dialog from 'components/dialog';
import DarkerGrainBg from 'images/gbp-grain-darker.png';
import GivebutterPlusLogo from 'images/givebutter-plus-logo.svg';
import WelcomeImg from 'images/givebutter-plus-welcome.webp';

interface GivebutterPlusWelcomeDialogProps extends Dialog.DialogProps {}

const GivebutterPlusWelcomeDialog = (props: GivebutterPlusWelcomeDialogProps) => {
    const { children, ...rest } = props;

    return (
        <Dialog.Root {...rest}>
            {children}
            <Dialog.Portal>
                <Dialog.Overlay />
                <Dialog.Content className="flex w-full max-w-3xl p-0">
                    <div className="flex flex-1 flex-col gap-6 p-8">
                        <div className="flex flex-col gap-4">
                            <div className="text-2xl">Welcome to</div>
                            <div>
                                <img
                                    className={'w-full max-w-[16.875rem]'}
                                    src={GivebutterPlusLogo}
                                    alt="Givebutter Plus logo"
                                />
                            </div>
                        </div>
                        <div className="text-gray-600">
                            We're excited that you've unlocked the full potential of Givebutter!
                            Start a guided tour now to explore all the powerful features at your
                            fingertips.
                        </div>
                        <div className="flex gap-3">
                            <Dialog.Cancel asChild>
                                <Button variant="outline" color="neutral" className="flex-1">
                                    Get started
                                </Button>
                            </Dialog.Cancel>
                            <Dialog.Cancel asChild>
                                <Button
                                    variant="solid"
                                    className="flex-1"
                                    onClick={() => {
                                        startTour(
                                            import.meta.env
                                                .VITE_DASHBOARD_INTERCOM_GBPLUS_WELCOME_TOUR_ID,
                                        );
                                    }}
                                >
                                    Take a tour
                                </Button>
                            </Dialog.Cancel>
                        </div>
                    </div>
                    <div
                        className="hidden flex-1 items-center justify-center p-8 sm:flex"
                        style={{
                            background: `url("${DarkerGrainBg}") repeat`,
                        }}
                    >
                        <img src={WelcomeImg} alt="Welcome to Givebutter Plus" />
                    </div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};

const GivebutterPlusWelcomeDialogTrigger = Dialog.Trigger;
const Root = GivebutterPlusWelcomeDialog;

const Trigger = GivebutterPlusWelcomeDialogTrigger;

export { GivebutterPlusWelcomeDialog, GivebutterPlusWelcomeDialogTrigger, Root, Trigger };
